import { api } from "@/lib/api";
import type { Page } from "@/features/users/api";

export interface AuditLog {
  id: string;
  action: string;
  actor_id: string | null;
  actor_email: string | null;
  entity_type: string | null;
  entity_id: string | null;
  ip_address: string | null;
  detail: Record<string, unknown> | null;
  created_at: string;
}

export interface AuditFilters {
  page?: number | undefined;
  action?: string | undefined;
  start?: string | undefined; // YYYY-MM-DD (IST)
  end?: string | undefined; // YYYY-MM-DD (IST), inclusive
}

export function listAuditLogs(params: AuditFilters = {}): Promise<Page<AuditLog>> {
  const q = new URLSearchParams();
  if (params.page) q.set("page", String(params.page));
  if (params.action) q.set("action", params.action);
  if (params.start) q.set("start", params.start);
  if (params.end) q.set("end", params.end);
  const s = q.toString();
  return api.get<Page<AuditLog>>(`/audit-logs${s ? `?${s}` : ""}`);
}
